(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-details-drawer-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.getElementById("product-details-drawer");

    if (!drawer) return;

    // Open Drawer
    document.querySelectorAll("[data-product-details-open]").forEach(button => {

        button.addEventListener("click", (e) => {

            e.preventDefault();

            drawer.classList.add("active");
            document.body.classList.add("product-details-open");

        });

    });

    // Close Drawer
    drawer.querySelectorAll("[data-product-details-close]").forEach(button => {

        button.addEventListener("click", () => {

            drawer.classList.remove("active");
            document.body.classList.remove("product-details-open");

        });

    });

    // ESC Key
    document.addEventListener("keydown", (e) => {

        if (e.key === "Escape") {

            drawer.classList.remove("active");
            document.body.classList.remove("product-details-open");

        }

    });

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-drawer-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.getElementById("product-info-drawer");

    if (!drawer) return;

    // Open Drawer
    document.querySelectorAll("[data-product-info-drawer-open]").forEach(button => {

        button.addEventListener("click", (e) => {

            e.preventDefault();

            drawer.classList.add("active");
            document.body.classList.add("product-info-drawer-open");

        });

    });

    // Close Drawer
    drawer.querySelectorAll("[data-product-info-drawer-close]").forEach(button => {

        button.addEventListener("click", () => {

            drawer.classList.remove("active");
            document.body.classList.remove("product-info-drawer-open");

        });

    });

    // ESC Key
    document.addEventListener("keydown", (e) => {

        if (e.key === "Escape") {

            drawer.classList.remove("active");
            document.body.classList.remove("product-info-drawer-open");

        }

    });

});
  } catch(e) { console.error(e); }
})();

})();
